var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout__body"},[_c('iframe',{attrs:{"height":"100%","width":"100%","allowfullscreen":"true","src":_vm.url.link}})])}
var staticRenderFns = []

export { render, staticRenderFns }